export const SHOW_FUELING_PROCESS_CANCEL_EDIT =
  "supportui/FuelingProcessCancelEdit/SHOW_FUELING_PROCESS_CANCEL_EDIT";
export const HIDE_FUELING_PROCESS_CANCEL_EDIT =
  "supportui/FuelingProcessCancelEdit/HIDE_FUELING_PROCESS_CANCEL_EDIT";
export const CANCEL_FUELING_PROCESS =
  "supportui/FuelingProcessCancelEdit/CANCEL_FUELING_PROCESS";
export const CANCEL_FUELING_PROCESS_FAILED =
  "supportui/FuelingProcessCancelEdit/CANCEL_FUELING_PROCESS_FAILED";
